'use strict';

const { CLASSES } = require('./../utils/globals');
const SELECTORS = {
    body: 'body',
    inputFieldWrapper: '.js-field-wrapper',
    inputFieldInvalid: '.f-field.is-invalid',
    inputFieldIsInvalid: '.is-invalid',
    invalidFieldMessage: '.js-invalid-message',
    generalFormError: '.js-general-form-error',
};

/**
 * Validate form element.
 * @param {jQuery} element - Element witch need to valid
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateElement(element) {
    element.setCustomValidity('');
    if (!element.checkValidity()) {
        $(element).trigger('invalid', element.validity);
    } else {
        $(element).closest(SELECTORS.inputFieldWrapper).find(SELECTORS.invalidFieldMessage).empty();
        $(element).closest(SELECTORS.inputFieldWrapper).find(SELECTORS.inputFieldInvalid).removeClass(CLASSES.isInvalid);
        $(element).closest(SELECTORS.inputFieldWrapper).find(SELECTORS.inputFieldIsInvalid).removeClass(CLASSES.isInvalid);
        $(element).closest(SELECTORS.inputFieldWrapper).removeClass(CLASSES.isInvalid);
    }
}

/**
 * Validate whole form. Requires `this` to be set to form object
 * @param {jQuery.event} event - Event to be canceled if form is invalid.
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateForm(event) {
    var valid = true;
    if (this.checkValidity && !this.checkValidity()) {
        // safari
        valid = false;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }

        $(this).find('input, select, textarea').each(function () {
            validateElement(this);
        });

        // Move focus to the first invalid field so keyboard and screen reader users
        // land on the error instead of being left on the submit button (WCAG 2.4.3 / 3.3.1).
        var firstInvalid = $(this).find('input, select, textarea').filter(function () {
            return this.willValidate && this.validity && !this.validity.valid;
        }).first();

        if (firstInvalid.length) {
            firstInvalid.focus();
        }
    } else {
        $(SELECTORS.generalFormError).empty();
    }
    return valid;
}

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearForm(form) {
    $(form).find(SELECTORS.inputFieldInvalid).removeClass(CLASSES.isInvalid);
    $(form).find(SELECTORS.generalFormError).empty();

    $('body').on('form:clear', function (e, data) {
        data.form.find(SELECTORS.inputFieldInvalid).removeClass(CLASSES.isInvalid);
        data.form.find(SELECTORS.generalFormError).empty();
    });
}

module.exports = {
    invalid: function () {
        $(SELECTORS.body).on('invalid', 'form input, form select, form textarea', function (e) {
            e.preventDefault();
            this.setCustomValidity('');

            if (!this.validity.valid) {
                var validationMessage = this.validationMessage;
                $(this).parent().addClass(CLASSES.isInvalid);

                if (this.validity.patternMismatch && $(this).data('pattern-mismatch')) {
                    validationMessage = $(this).data('pattern-mismatch');
                }
                if ((this.validity.rangeOverflow || this.validity.rangeUnderflow)
                    && $(this).data('range-error')) {
                    validationMessage = $(this).data('range-error');
                }
                if (this.validity.rangeUnderflow && $(this).data('range-min-error')) {
                    validationMessage = $(this).data('range-min-error');
                }
                if (this.validity.rangeOverflow && $(this).data('range-max-error')) {
                    validationMessage = $(this).data('range-max-error');
                }
                if ((this.validity.tooLong || this.validity.tooShort)
                    && $(this).data('range-error')) {
                    validationMessage = $(this).data('range-error');
                }
                if (this.validity.valueMissing && $(this).data('missing-error')) {
                    validationMessage = $(this).data('missing-error');
                }

                $(this).parents(SELECTORS.inputFieldWrapper).find(SELECTORS.invalidFieldMessage)
                    .text(validationMessage);
            }
        });
    },

    submit: function () {
        $('form').on('submit', function (e) {
            return validateForm.call(this, e);
        });
    },

    inputChange: function () {
        $('body').on('focusout', 'form input', function () {
            validateElement(this);
            $(SELECTORS.generalFormError).empty();
        });
    },

    selectChange: function () {
        $('body').on('select2:close', 'form .js-select, form .js-select-dropdown-below', function () {
            if (!$(this).hasClass('required')) {
                return;
            }

            validateElement(this);
        });

        $('body').on('change', 'form select.required', function() {
            validateElement(this);
        });
    },

    customFieldError: function () {
        $('body').on('field:error', function (e, data) {
            data.element.parent().addClass(CLASSES.isInvalid);
            data.element.parents(SELECTORS.inputFieldWrapper).find(SELECTORS.invalidFieldMessage).text(data.message);
        });
    },

    functions: {
        validateForm: function (form, event) {
            validateForm.call($(form), event || null);
        },
        clearForm: clearForm
    }
}
